const TajikistanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112518)">
      <path
        d="M1.98453 11.3046C0.713125 13.9339 0 16.8838 0 20.0002C0 23.1166 0.713125 26.0664 1.98453 28.6958L20 30.435L38.0155 28.6958C39.2869 26.0664 40 23.1166 40 20.0002C40 16.8838 39.2869 13.9339 38.0155 11.3046L20 9.56543L1.98453 11.3046Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.98486 28.6953C5.21979 35.3852 12.0705 39.9997 19.9996 39.9997C27.9288 39.9997 34.7795 35.3852 38.0144 28.6953H1.98486Z"
        fill="#6DA544"
      />
      <path
        d="M1.98486 11.3044H38.0144C34.7795 4.61453 27.9288 0 19.9996 0C12.0705 0 5.21979 4.61453 1.98486 11.3044Z"
        fill="#D80027"
      />
      <path
        d="M16.5215 25.218H23.478V22.2614L22.0867 22.9571L19.9998 20.8701L17.9128 22.9571L16.5215 22.2614V25.218Z"
        fill="#FFDA44"
      />
      <path
        d="M12.5414 21.7383L12.8652 22.7347H13.9129L13.0652 23.3505L13.3891 24.347L12.5414 23.7312L11.6938 24.347L12.0176 23.3505L11.1699 22.7347H12.2176L12.5414 21.7383Z"
        fill="#FFDA44"
      />
      <path
        d="M13.5458 18.2598L13.8696 19.2562H14.9173L14.0696 19.872L14.3934 20.8684L13.5458 20.2527L12.6981 20.8684L13.022 19.872L12.1743 19.2562H13.222L13.5458 18.2598Z"
        fill="#FFDA44"
      />
      <path
        d="M16.4149 15.6514L16.7388 16.6478H17.7863L16.9388 17.2636L17.2625 18.26L16.4149 17.6443L15.5674 18.26L15.8911 17.2636L15.0435 16.6478H16.0912L16.4149 15.6514Z"
        fill="#FFDA44"
      />
      <path
        d="M27.4579 21.7383L27.1341 22.7347H26.0864L26.9341 23.3505L26.6103 24.347L27.4579 23.7312L28.3055 24.347L27.9817 23.3505L28.8294 22.7347H27.7817L27.4579 21.7383Z"
        fill="#FFDA44"
      />
      <path
        d="M26.455 18.2598L26.1312 19.2562H25.0835L25.9312 19.872L25.6073 20.8684L26.455 20.2527L27.3026 20.8684L26.9788 19.872L27.8265 19.2562H26.7788L26.455 18.2598Z"
        fill="#FFDA44"
      />
      <path
        d="M23.5848 15.6514L23.261 16.6478H22.2134L23.0609 17.2636L22.7371 18.26L23.5848 17.6443L24.4324 18.26L24.1086 17.2636L24.9562 16.6478H23.9085L23.5848 15.6514Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9999 14.3486L20.3237 15.345H21.3714L20.5237 15.9609L20.8476 16.9573L19.9999 16.3415L19.1522 16.9573L19.4761 15.9609L18.6284 15.345H19.6761L19.9999 14.3486Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112518">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TajikistanSvg;
